/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { RelevanceScore } from '../../../relevance/relevance-score';
import { useTranslation } from 'react-i18next';
import { tokens } from '@/locales/translations/tokens';

interface BaseCardHeaderProps {
  title: string;
  backgroundColor?: string;
  relevanceValue: number;
  groupedCards?: any[];
  currentCardIndex: number;
  onClose: () => void;
  children: React.ReactNode;
  showGradient?: boolean;
  isVideo?: boolean;
}

export const BaseCardHeader: React.FC<BaseCardHeaderProps> = ({
  title,
  backgroundColor,
  relevanceValue,
  groupedCards,
  currentCardIndex,
  onClose,
  children,
  showGradient = true,
  isVideo = false
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex-shrink-0'>
      <div className='relative'>
        <button
          className='absolute right-4 top-4 z-50 flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-white transition-colors hover:bg-white/40'
          onClick={onClose}
          aria-label='Close'
        >
          <X size={20} />
        </button>

        <div
          className={`group relative h-[200px] w-full overflow-hidden sm:h-[${isVideo ? "450px" : "250px"}] md:h-[${isVideo ? "450px" : "250px"}]`}
          style={{
            background: isVideo ? 'transparent' : (backgroundColor || 'hsl(var(--primary))'),
          }}
        >
          {children}

          {!isVideo && showGradient && (
            <div className='absolute inset-0 bg-gradient-to-t from-black/70 to-transparent'></div>
          )}
          
          {!isVideo && (
            <div className={`absolute bottom-4 right-4 z-20 ${isVideo ? 'bg-black/40 rounded-lg p-2' : ''}`}>
              <RelevanceScore value={relevanceValue} />
            </div>
          )}
        </div>
        
        {!isVideo && (
          <div className={`absolute bottom-0 left-0 z-10 max-w-[70%] p-6 ${isVideo ? 'bg-black/40 backdrop-blur-sm rounded-tr-lg' : ''}`}>
            <h2 className='line-clamp-2 text-xl font-semibold text-white sm:text-2xl'>
              {title}
            </h2>
            <div className='mt-2 flex flex-wrap items-center gap-2'>
             {groupedCards && groupedCards.length > 1 && (
                <span className='inline-flex items-center gap-1 rounded-md bg-primary/40 px-2.5 py-0.5 text-xs font-medium text-white'>
                  <motion.span
                    key={currentCardIndex}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.2 }}
                  >
                    {currentCardIndex + 1}
                  </motion.span>
                  <span className='opacity-70'>{t(tokens.ui.common.of)}</span>
                  <span>{groupedCards.length}</span>
                </span>
              )}
            </div>
          </div>
        )}
      </div>

      <div className='h-1 w-full bg-border/10'></div>
    </div>
  );
};